import api from "@/lib/api";

export const feedbackService = {
  submit: ({ type, title, message, url, user_agent, viewport, screenshot }) => {
    const fd = new FormData();
    fd.append("type", type);
    fd.append("title", title || "");
    fd.append("message", message);
    fd.append("url", url || "");
    fd.append("user_agent", user_agent || "");
    fd.append("viewport", viewport || "");
    if (screenshot) fd.append("screenshot", screenshot);
    return api.post("/feedback", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};
